import type {ExamModuleDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import getExamModulesCollection from './getExamModulesCollection';

export default function getExamModuleDocRef(id: string): DocumentReference<ExamModuleDb> {
  return doc(getExamModulesCollection(), id);
}
